import { STATUS_STYLES } from "@/lib/format";
import { useI18n } from "@/context/I18nContext";

// Legacy orders may still carry "completed"; the lifecycle now ends at "delivered".
const NORMALIZE = { completed: "delivered" };

export function StatusBadge({ status }) {
  const { t } = useI18n();
  const s = NORMALIZE[status] || status;
  const cls = STATUS_STYLES[s] || "bg-slate-100 text-slate-600 border border-slate-200";
  const key = `ostatus.${s}`;
  const label = t(key);
  const text = label && label !== key ? label : String(s || "").replace(/_/g, " ");
  return (
    <span
      data-testid={`status-badge-${s}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize ${cls}`}
    >
      {text}
    </span>
  );
}
